import type { Template } from "@/types";

export const PO_07_H7_V0: Template[] = [
{
    id: "po-07-h7v0-01",
    name: "PO 01 - H7V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h7_v0_01.png",
    size: [1136, 854],
    style: {},
        slots: [      
            { id: "1", x: 38, y: 242, width: 242, height: 181, rotation: 0, imageRotation: 0 },
            { id: "2", x: 38, y: 431, width: 242, height: 181, rotation: 0, imageRotation: 0 },
            { id: "3", x: 288, y: 242, width: 242, height: 181, rotation: 0, imageRotation: 0 },
            { id: "4", x: 288, y: 431, width: 242, height: 181, rotation: 0, imageRotation: 0 },
            { id: "5", x: 638, y: 182, width: 424, height: 323, rotation: 0, imageRotation: 0 },
            { id: "6", x: 638, y: 513, width: 208, height: 160, rotation: 0, imageRotation: 0 },
            { id: "7", x: 854, y: 513, width: 208, height: 160, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-07-h7v0-02",
    name: "PO 02 - H7V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h7_v0_02.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 58, y: 257, width: 451, height: 338, rotation: 0, imageRotation: 0 },
        { id: "2", x: 628, y: 172, width: 222, height: 165, rotation: 0, imageRotation: 0 },
        { id: "3", x: 628, y: 345, width: 222, height: 164, rotation: 0, imageRotation: 0 },
        { id: "4", x: 628, y: 517, width: 222, height: 164, rotation: 0, imageRotation: 0 },
        { id: "5", x: 858, y: 172, width: 221, height: 165, rotation: 0, imageRotation: 0 },
        { id: "6", x: 858, y: 345, width: 221, height: 164, rotation: 0, imageRotation: 0 },
        { id: "7", x: 858, y: 517, width: 221, height: 164, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h7v0-03",
    name: "PO 03 - H7V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h7_v0_03.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 47, y: 183, width: 484, height: 361, rotation: 0, imageRotation: 0 },     
        { id: "2", x: 47, y: 552, width: 156, height: 120, rotation: 0, imageRotation: 0 },
        { id: "3", x: 211, y: 552, width: 156, height: 120, rotation: 0, imageRotation: 0 },
        { id: "4", x: 375, y: 552, width: 155, height: 120, rotation: 0, imageRotation: 0 },
        { id: "5", x: 611, y: 155, width: 484, height: 351, rotation: 0, imageRotation: 0 },
        { id: "6", x: 611, y: 514, width: 238, height: 186, rotation: 0, imageRotation: 0 },
        { id: "7", x: 857, y: 514, width: 237, height: 186, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h7v0-04",
    name: "PO 04 - H7V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h7_v0_04.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 36, y: 242, width: 495, height: 370, rotation: 0, imageRotation: 0 },
        { id: "2", x: 604, y: 242, width: 160, height: 118, rotation: 0, imageRotation: 0 },
        { id: "3", x: 604, y: 368, width: 160, height: 118, rotation: 0, imageRotation: 0 },
        { id: "4", x: 604, y: 494, width: 160, height: 118, rotation: 0, imageRotation: 0 },
        { id: "5", x: 772, y: 242, width: 160, height: 118, rotation: 0, imageRotation: 0 },
        { id: "6", x: 940, y: 242, width: 160, height: 118, rotation: 0, imageRotation: 0 },
        { id: "7", x: 772, y: 368, width: 328, height: 244, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h7v0-05",
    name: "PO 05 - H7V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h7_v0_05.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 64, y: 165, width: 500, height: 364, rotation: 0, imageRotation: 0 },
        { id: "2", x: 572, y: 165, width: 500, height: 364, rotation: 0, imageRotation: 0 },
        { id: "3", x: 64, y: 537, width: 196, height: 152, rotation: 0, imageRotation: 0 },
        { id: "4", x: 268, y: 537, width: 195, height: 152, rotation: 0, imageRotation: 0 },
        { id: "5", x: 471, y: 537, width: 195, height: 152, rotation: 0, imageRotation: 0 },
        { id: "6", x: 674, y: 537, width: 195, height: 152, rotation: 0, imageRotation: 0 },
        { id: "7", x: 877, y: 537, width: 195, height: 152, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h7v0-06",
    name: "PO 06 - H7V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h7_v0_06.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 49, y: 197, width: 254, height: 193, rotation: 0, imageRotation: 0 },
        { id: "2", x: 311, y: 197, width: 254, height: 193, rotation: 0, imageRotation: 0 },
        { id: "3", x: 573, y: 197, width: 254, height: 193, rotation: 0, imageRotation: 0 },
        { id: "4", x: 835, y: 197, width: 253, height: 193, rotation: 0, imageRotation: 0 },
        { id: "5", x: 49, y: 398, width: 341, height: 260, rotation: 0, imageRotation: 0 },
        { id: "6", x: 398, y: 398, width: 341, height: 260, rotation: 0, imageRotation: 0 },
        { id: "7", x: 747, y: 398, width: 340, height: 260, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h7v0-07",
    name: "PO 07 - H7V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h7_v0_07.png",
    size: [1136, 854],
    style: {},
    slots: [      
        { id: "1", x: 0, y: 205, width: 183, height: 143, rotation: 0, imageRotation: 0 },
        { id: "2", x: 0, y: 356, width: 183, height: 143, rotation: 0, imageRotation: 0 },
        { id: "3", x: 0, y: 507, width: 183, height: 142, rotation: 0, imageRotation: 0 },
        { id: "4", x: 191, y: 507, width: 183, height: 142, rotation: 0, imageRotation: 0 },
        { id: "5", x: 382, y: 507, width: 182, height: 142, rotation: 0, imageRotation: 0 },
        { id: "6", x: 191, y: 205, width: 373, height: 294, rotation: 0, imageRotation: 0 },
        { id: "7", x: 572, y: 205, width: 564, height: 444, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h7v0-08",
    name: "PO 08 - H7V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h7_v0_08.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 0, y: 205, width: 564, height: 444, rotation: 0, imageRotation: 0 },
        { id: "2", x: 572, y: 205, width: 183, height: 143, rotation: 0, imageRotation: 0 },
        { id: "3", x: 572, y: 356, width: 183, height: 143, rotation: 0, imageRotation: 0 },
        { id: "4", x: 572, y: 507, width: 183, height: 142, rotation: 0, imageRotation: 0 },
        { id: "5", x: 763, y: 507, width: 183, height: 142, rotation: 0, imageRotation: 0 },
        { id: "6", x: 954, y: 507, width: 182, height: 142, rotation: 0, imageRotation: 0 },
        { id: "7", x: 763, y: 205, width: 373, height: 294, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h7v0-09",
    name: "PO 09 - H7V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h7_v0_09.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 0, y: 205, width: 564, height: 444, rotation: 0, imageRotation: 0 },
        { id: "2", x: 572, y: 205, width: 183, height: 143, rotation: 0, imageRotation: 0 },
        { id: "3", x: 763, y: 205, width: 183, height: 143, rotation: 0, imageRotation: 0 },
        { id: "4", x: 954, y: 205, width: 182, height: 143, rotation: 0, imageRotation: 0 },
        { id: "5", x: 954, y: 356, width: 182, height: 143, rotation: 0, imageRotation: 0 },
        { id: "6", x: 954, y: 507, width: 182, height: 142, rotation: 0, imageRotation: 0 },
        { id: "7", x: 572, y: 356, width: 374, height: 293, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h7v0-10",
    name: "PO 10 - H7V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h7_v0_10.png",
    size: [1136, 854],
    style: {},
    slots: [       
        { id: "1", x: 44, y: 185, width: 212, height: 157, rotation: 0, imageRotation: 0 },
        { id: "2", x: 44, y: 350, width: 212, height: 156, rotation: 0, imageRotation: 0 },
        { id: "3", x: 44, y: 514, width: 212, height: 156, rotation: 0, imageRotation: 0 },
        { id: "5", x: 264, y: 185, width: 608, height: 485, rotation: 0, imageRotation: 0 },
        { id: "5", x: 880, y: 185, width: 212, height: 157, rotation: 0, imageRotation: 0 },
        { id: "6", x: 880, y: 350, width: 212, height: 156, rotation: 0, imageRotation: 0 },
        { id: "7", x: 880, y: 514, width: 212, height: 156, rotation: 0, imageRotation: 0 }
    ],
}

];